import initialState from './../../initialState';

export default (state = initialState.quantidadeErros, { type, value, response }) => {
  switch (type) {
    case 'COUNT_ERROS_REQUEST':
      return {
        fetching: 1,
        errors: []
      }
    case 'COUNT_ERROS_SUCCESS':
      return {
        fetching: 2,
        ...response
      }
    case 'COUNT_ERROS_FAILURE':
      return {
        fetching: 0,
        count: 0,
        ...response
      }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/modules/admin/reducerQuantidadeErros.js